import React, { useEffect, useState } from "react";
import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage";
import createPNUDTitle from "../../../utils/functions/createPNUDTitle";
import TEXT from "../../../utils/text/pnudBook.json";
import SurveyGraphSection from "../../reusable/SurveyGraphSection/SurveyGraphSection";
import DATA from "../../../utils/PNUD/diversity.json";
import { TOOLTIP_STYLE } from "../../../utils/constants/graphConfigs";
import { getCountryName } from "../../../utils/constants/nameCountry";
import CardSurveys from "../../reusable/CardSurveys";
import { formatNumber } from "../../../utils/functions/formatNumber";

function DiversityScatter({ isLoadingFlags, flags }) {
  const { language } = useCurrentLanguage();

  const [options, setOptions] = useState();
  const [questionsList] = useState(TEXT["diversity"]["questions"][language]);
  const [pointsList] = useState(DATA["points"]);

  useEffect(() => {
    if (!isLoadingFlags) {
      setOptions({
        xAxis: {
          name: questionsList[0],
          nameLocation: "middle",
          nameGap: 30,
          nameTextStyle: {
            fontFamily: ["Open Sans", "sans-serif"],
            fontSize: 14,
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            formatter: "{value}pp",
          },
        },
        yAxis: {
          name: questionsList[1],
          nameLocation: "middle",
          nameRotate: 90,
          nameGap: 34,
          nameTextStyle: {
            fontFamily: ["Open Sans", "sans-serif"],
            fontSize: 14,
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            formatter: "{value}pp",
          },
        },
        grid: {
          width: "77%",
          left: "17%",
          height: "80%",
          right: "7%",
          top: "5%",
        },
        series: [
          {
            symbolSize: 40,
            data: pointsList,
            type: "scatter",
            symbol: (value, params) => {
              return "image://" + flags[params.dataIndex];
            },
          },
        ],
        tooltip: {
          show: true,
          ...TOOLTIP_STYLE,
          valueFormatter: (value) => value + "%",
          formatter: (params) => {
            let elements = [];

            elements.push("<div>");
            elements.push(
              "<span>" +
                getCountryName(
                  DATA["countries"][params.dataIndex],
                  language,
                  true
                ) +
                "</span>"
            );
            elements.push(
              "<div>" +
                questionsList[0] +
                ": <span>" +
                formatNumber(params.data[0].toFixed(1), language) +
                "pp</span></div>"
            );
            elements.push(
              "<div>" +
                questionsList[1] +
                ": <span>" +
                formatNumber(params.data[1].toFixed(1), language) +
                "pp</span></div>"
            );
            elements.push("</div>");

            return elements.join(" ");
          },
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoadingFlags]);

  return (
    <>
      <div className="pnud-graph-content">
        <CardSurveys
          isLoading={isLoadingFlags}
          options={options}
          isGraphLeft={true}
        />
      </div>

      <div className="pnud-graph-note">{TEXT["notePP"][language]}</div>
    </>
  );
}

export default function PNUDDiversity({ textPlacement }) {
  const { language } = useCurrentLanguage();
  const [isLoadingFlags, setIsLoadingFlags] = useState(true);
  const [flags, setFlags] = useState([]);

  useEffect(() => {
    const getFlags = async () => {
      // load images
      const flagImages = [];
      const countries = DATA["countries"];
      countries.forEach((e) => {
        flagImages.push(require("../../../images/flags/" + e + ".png"));
      });

      setFlags(flagImages);
      setIsLoadingFlags(false);
    };

    getFlags();
  }, []);

  return (
    <SurveyGraphSection
      graphID={"pnud-acceptance"}
      textPlacement={textPlacement}
      title={createPNUDTitle(TEXT["diversity"]["title"], language)}
      description={TEXT["diversity"]["description"][language]}
      language={language}
      graphComponent={
        <DiversityScatter isLoadingFlags={isLoadingFlags} flags={flags} />
      }
      source={TEXT["source"][language]}
    />
  );
}
